package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.ServiceRepository

class DeleteServiceUseCase(
    private val repository: ServiceRepository
) {
    suspend operator fun invoke(serviceId: String): Result<Unit> {
        if (serviceId.isBlank()) {
            return Result.failure(IllegalArgumentException("ID do serviço é obrigatório."))
        }
        return repository.deleteService(serviceId)
    }
}
